<template>
  <span>{{ formatted }}</span>
</template>

<script>
import { DateTime } from "luxon";

export default {
  name: "Timestamp",
  props: {
    time: Number | String,
    format: {
      required: false,
      type: String,
    },
    placeholder: {
      required: false,
      type: String,
    },
  },
  computed: {
    formatted: function () {
      if (this.time) {
        // If it's a number or numeric string, treat as seconds
        if (!isNaN(this.time) && Number.isFinite(Number(this.time))) {
          return DateTime.fromSeconds(Number(this.time)).toFormat(
            this.format || "dd/MM/yyyy HH:mm:ss"
          );
        }
        // Otherwise, treat as ISO string
        return DateTime.fromISO(this.time).toFormat(
          this.format || "dd/MM/yyyy HH:mm:ss"
        );
      }
      return this.placeholder || "";
    },
  },
};
</script>

<style scoped></style>
